<template>
    <div>
        <kendo-multiselect
            v-if="loaded"
            v-model="selectedValues"
            :data-source="items"
            :data-text-field="'text'"
            :disabled="details || model.isReadOnly"
            :data-value-field="'id'"
            :data-placeholder="$t('choose')"
            @change="inputChanged"
            :name="'dropdown' + _uid"
            :filter="filterPattern"
            :data-vv-as="fieldName"
            v-validate="model.isRequired ? 'required' : ''"
            :height="height"
            style="width: 100%;"
            :footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
        ></kendo-multiselect>
        <span
            class="text-danger col-12"
            v-if="errors.has('dropdown' + _uid)"
        >{{ errors.first('dropdown' + _uid) }}</span>

        <DropdownSettings
            v-if="loaded"
            :filterPattern.sync="filterPattern"
            :show.sync="showSettings"
        ></DropdownSettings>
    </div>
</template>

<script>
import Vue from "vue";
import FooterTemplate from "../../components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "../../components/common/DropdownSettings";
import { EditorComponentModel } from "../../models/models";
import { mapGetters } from "vuex";

export default {
    inject: ["$validator"],
    props: {
        value: [String, Number],
        fieldName: String,
        model: EditorComponentModel,
        details: {
            type: Boolean,
            default: false,
        },
        height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        },
    },
    components: {
        DropdownSettings,
    },
    data() {
        return {
            loaded: false,
            items: [],
            selectedValues: [],
            showSettings: false,
            filterPattern: "",
        };
    },
    methods: {
        init() {
            const url = `/api/Dropdown/GetStaticRegisterItems?registerId=${this.model.dropdownId}&selected=${this.value}
            &updateTime=${this.model.fieldValue.updateTime ? new Date(this.model.fieldValue.updateTime).toISOString() : new Date().toISOString()}`;
            this.$http
                .get(url)
                .then((result) => {
                    this.items = result.data;
                    this.selectedValues = this.model.fieldValue.textValue.split(
                        "|"
                    );
                    this.populateStringValueById(this.selectedValues);
                    this.loaded = true;
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: "warning",
                        time: this.$store.getters.notificationDuration,
                    });
                });
        },
        inputChanged(event) {
            let valueToEmit = event.sender.value().join("|");
            this.$emit("input", valueToEmit);
            this.populateStringValueById(event.sender.value());
        },
        populateStringValueById(ids) {
            if (Array.isArray(ids) === false) {
                return;
            }

            let stringValues = [];
            let vm = this;
            ids.forEach((id) => {
                // eslint-disable-next-line eqeqeq
                const val = vm.items.filter((item) => item.id == id);
                if (val && val.length > 0) {
                    stringValues.push(val[0].text);
                }
            });
            if (stringValues.length > 0) {
                this.model.fieldValue.stringValue = stringValues.join(",");
            }
        },
        footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "staticRegisterMultiSelectSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
    },
    computed: {
        ...mapGetters(['nomDropdownSettings']),
    },
    mounted() {
        this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
        this.init();
    },
};
</script>
